'use client'

import { DownloadIcon } from '../../icons'
import {
    ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS,
    resolveIconButtonAriaLabel,
} from '../../../constants/iconButtonAriaLabelMessageKeys'
import { EMPTY_VALUE } from '../../../constants/stringConstants'
import { DictionaryContext } from '../../../providers'
import { File, TextTypes } from '../../../types'
import React, { ReactElement, useContext } from 'react'
import { Button, ButtonVariants } from '../Button'
import { Text } from '../Text'
import { Truncate } from '../Truncate'
import { Card } from './Card'

interface FileCardProps extends React.HTMLAttributes<HTMLDivElement> {
    file: File
    downloadFile?: (file: File) => void
}

export const FileCard = ({ file, downloadFile, ...props }: FileCardProps): ReactElement | null => {
    const dictionary = useContext(DictionaryContext)

    if (!file?.id) return null

    const handleDownload = () => {
        if (downloadFile) downloadFile(file)
    }

    return (
        <Card
            {...props}
            className={`flex items-center ${props.className ?? ''}`}
            dense
            actions={
                <Button
                    icon={<DownloadIcon />}
                    onClick={handleDownload}
                    variant={ButtonVariants.QUIET}
                    aria-label={resolveIconButtonAriaLabel(
                        dictionary,
                        ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS.DOWNLOAD_FILE,
                    )}
                />
            }
        >
            <button className="inline-flex max-w-full" onClick={handleDownload}>
                <Text type={TextTypes.LINK} className="inline-flex max-w-full">
                    <Truncate text={file.name ?? EMPTY_VALUE} />
                </Text>
            </button>
        </Card>
    )
}
